<script>import { createEventDispatcher } from "svelte";
import ChevronDown from "../../icons/ChevronDown.svelte";
import { DropdownPositionsEnum } from "../../typings/DropdownPositionsEnum.js";
import { clickOutside } from "../../utils/clickOutside.js";
import { cn } from "../../utils/twClnm.js";
import SortButton from "../Sort/SortButton.svelte";
import { SortStatesEnum } from "../../typings/SortStates.js";
import IconInput from "../IconInput/IconInput.svelte";
export let list = [];
export let initialText = list?.[0]?.name || "";
export let showSearch = true;
export let position = DropdownPositionsEnum.BottomRight;
export let label = "";
export let totalWidth = "";
export let listClass = "";
export let itemsClass = "";
export let initialTextClass = "";
export let initialTextInnerClass = "";
export let dropdownClass = "";
export let itemClass = "";
export let sortButton = false;
export let sortOrder = SortStatesEnum.Descending;
let isOpened = false;
$: filteredList = list;
$: reactiveSortOrder = sortOrder;
const dispatch = createEventDispatcher();
const switchOpened = () => isOpened = !isOpened;
const dispatchItemClick = (index, e) => {
  const selectedIndex = list?.findIndex(
    (item) => item.name?.toLowerCase() === e.target.innerText?.toLowerCase()
  );
  dispatch("select", {
    index: selectedIndex,
    item: list[selectedIndex]
  });
  isOpened = false;
  initialText = filteredList[index]?.name;
  filteredList = list;
};
const sortChange = (toggle) => {
  dispatch("select", {
    sortOrder: toggle.detail.activeState
  });
};
const onClickOutside = () => {
  isOpened = false;
  filteredList = list;
};
const onSearchFilter = ({ detail }) => {
  const { value } = detail;
  filteredList = list.filter(
    (item) => item?.name?.toLowerCase().replaceAll(" ", "").includes(value.toLowerCase().replaceAll(" ", ""))
  );
};
let widthDevide = 1;
if (label) widthDevide += 1;
if (sortButton) widthDevide += 1;
let totalwidth = totalWidth;
let widthClass1;
let widthClass2;
let widthClass3;
switch (widthDevide) {
  case 3:
    totalwidth = `auto`;
    break;
  case 2:
    widthClass1 = widthClass2 = widthClass3 = "tw-w-1/2";
    break;
  default:
    widthClass1 = widthClass2 = widthClass3 = "tw-w-auto";
}
;
</script>

<div
	style="width: {totalwidth};"
	class={cn("tw-relative hover:tw-bg-gray-50 tw-inline-flex tw-max-h-96 tw-justify-center gap-2", $$restProps.class)}
	use:clickOutside={onClickOutside}
>
	{#if label}
		<span
			class={cn(`tw-grow tw-text-sm tw-font-semibold tw-leading-none tw-text-neutral-800`, widthClass2)}
			>{label}</span
		>
	{/if}

	<div
		class={cn(`tw-inline-flex tw-items-center 
		tw-justify-center tw-gap-x-1.5 tw-px-1 tw-py-2
		`, initialTextClass, widthClass1)}
		role="button"
		tabindex="0"
		on:keydown={()=>{}}
		on:click={switchOpened}
	>
		<span class={cn("tw-line-clamp-1", initialTextInnerClass)}>{initialText}</span>
		<ChevronDown></ChevronDown>
	</div>
	{#if sortButton}
		<button class={`${widthClass3}`}>
			<SortButton defaultState={reactiveSortOrder} on:toggleNext={sortChange} />
		</button>
	{/if}

	{#if isOpened}
		<div
			class={cn({
				[`tw-absolute 
			tw-z-50 tw-inline-flex tw-max-h-96 
			tw-w-48 tw-flex-col tw-items-start 
			tw-justify-start tw-gap-5 tw-rounded-md 
			tw-border tw-border-zinc-200 
			tw-bg-white tw-p-3.5 tw-pr-0 
			tw-shadow`]: true,
			'tw-left-0 tw-top-8': position === DropdownPositionsEnum.BottomRight,
			'tw-right-0 tw-top-8': position === DropdownPositionsEnum.BottomLeft,
			}, dropdownClass)}
			role="menu"
			aria-orientation="vertical"
			aria-labelledby="menu-button"
			tabindex="-1"
		>
			{#if showSearch}
				<IconInput on:input={onSearchFilter}></IconInput>
			{/if}

			<div
				class={cn(
					[`tw-inline-flex tw-w-full tw-flex-col 
					tw-items-start tw-justify-start 
					tw-gap-5 tw-overflow-y-auto tw-py-1 
					tw-scrollbar-thin tw-scrollbar-track-gray-100 
					tw-scrollbar-thumb-gray-800`],
					[listClass]
				)}
				role="none"
			>
				{#each filteredList as item, index}
					<button class={cn("tw-w-full", itemClass)} on:click={(e)=>dispatchItemClick(index, e)}
						><span
							class={cn(`tw-inline-block tw-w-full tw-overflow-hidden 
							tw-break-words tw-whitespace-normal tw-py-1`, itemsClass)}
							>{item?.name}</span
						>
					</button>
				{/each}
			</div>
		</div>
	{/if}
</div>
